<script lang="ts">
  import Brand from './Brand.svelte';
  import { installState } from '../lib/install.svelte';
</script>
<footer class="site-footer mt-5">
  <div class="container py-5">
    <div class="row g-4 align-items-start">
      <div class="col-lg-5"><Brand /><p class="mt-3 text-secondary" style="max-width:32rem">Joyful, safe, professionally managed mobile playground experiences for family celebrations.</p>{#if !installState.installed}<button type="button" class="footer-app" onclick={() => installState.start()}><img src="/icon-192.png" alt="" width="24" height="24" /> Get the Bibow app</button>{/if}</div>
      <div class="col-6 col-lg-2"><strong>Explore</strong><a href="/packages" data-spa>Packages</a><a href="/reviews" data-spa>Reviews</a><a href="/about" data-spa>About</a></div>
      <div class="col-6 col-lg-3"><strong>Ready to celebrate?</strong><a href="/book" data-spa>Start a booking</a><a href="/admin/login" data-spa>Staff login</a></div>
    </div>
    <div class="footer-line mt-4 pt-4 d-flex flex-wrap justify-content-between gap-2"><small>© {new Date().getFullYear()} Bibow Playground Rentals.</small><small>Where little smiles come to play.</small></div>
  </div>
</footer>

<style>
.footer-app{display:inline-flex;align-items:center;gap:.55rem;white-space:nowrap;margin-top:.25rem;padding:.4rem .85rem .4rem .45rem;border:1px solid #e7eaed;border-radius:999px;background:#fff;color:var(--slate);font-weight:800;font-size:.92rem}
.footer-app:hover{border-color:var(--play-orange);color:var(--play-orange)}
.footer-app img{border-radius:.4rem}
</style>
